import api from "./api";

export type PlatformSport = {
  id: string;
  name: string;
  icon: string | null;
  is_active: boolean;
  order_no: number;
  created_at: string;
  updated_at: string;
};

/**
 * Get all platform sports
 */
export async function getSports(showAll = false) {
  const qs = showAll ? "?all=true" : "";
  const { data } = await api.get<PlatformSport[]>(`/platform-sports${qs}`);
  return data;
}

/**
 * Create new sport
 */
export async function createSport(payload: {
  name: string;
  icon?: string;
  is_active?: boolean;
  order_no?: number;
}) {
  const { data } = await api.post<PlatformSport>("/platform-sports", payload);
  return data;
}

/**
 * Update sport
 */
export async function updateSport(
  sportId: string,
  payload: {
    name?: string;
    icon?: string;
    is_active?: boolean;
    order_no?: number;
  }
) {
  const { data } = await api.patch<PlatformSport>(`/platform-sports/${sportId}`, payload);
  return data;
}

/**
 * Delete sport
 */
export async function deleteSport(sportId: string) {
  const { data } = await api.delete(`/platform-sports/${sportId}`);
  return data;
}
